import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifyEmailFormComponent } from './verify-email-form.component';
import { TranslateModule } from '@xref/ngx';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [VerifyEmailFormComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FontAwesomeModule
  ],
  exports: [VerifyEmailFormComponent]
})
export class VerifyEmailFormModule {}
